import { dealsauceS3Url } from '@/utils/dealsauceS3'

export const PEP_HELMET = {
  titleText: 'Property Edge Pro',
  icon: dealsauceS3Url(
    'affiliateImages/6477d23419964974995227cf-230609210604-72796-pep-icon.png',
  ),
}

export const DEALSAUCE_HELMET = {
  titleText: 'Deal Sauce (Subto)',
  icon: dealsauceS3Url(
    'affiliateImages/-240417210421-70094-pace_morby_small.png',
  ),
}

const EXACT_HOST_MEMBERS = {
  'app.propertyedge.pro': 'pep',
  'old.propertyedge.pro': 'pep',
  'app.dealsauce.io': 'pacemorby',
  'old.dealsauce.io': 'pacemorby',
}

const EXACT_HOST_HELMET = {
  'app.propertyedge.pro': PEP_HELMET,
  'old.propertyedge.pro': PEP_HELMET,
  'app.dealsauce.io': DEALSAUCE_HELMET,
  'old.dealsauce.io': DEALSAUCE_HELMET,
  'dev-admin.housefolios.com': {
    titleText: 'Dev Testing for Housefolios',
    icon: '/images/defaultSidebarSmallLogo.png',
  },
}

function normalizeHost(hostname) {
  return String(hostname || '')
    .trim()
    .toLowerCase()
}

export function resolveUrlAffiliate(hostname) {
  const host = normalizeHost(hostname)
  if (!host) return ''
  if (EXACT_HOST_MEMBERS[host]) return EXACT_HOST_MEMBERS[host]
  if (host === 'propertyedge.pro' || host.endsWith('.propertyedge.pro')) {
    return 'pep'
  }
  if (host === 'dealsauce.io' || host.endsWith('.dealsauce.io')) {
    return 'pacemorby'
  }
  return ''
}

export function resolveUrlHelmetData(hostname) {
  const host = normalizeHost(hostname)
  if (!host) return undefined
  if (EXACT_HOST_HELMET[host]) return EXACT_HOST_HELMET[host]
  if (host === 'propertyedge.pro' || host.endsWith('.propertyedge.pro')) {
    return PEP_HELMET
  }
  if (host === 'dealsauce.io' || host.endsWith('.dealsauce.io')) {
    return DEALSAUCE_HELMET
  }
  return undefined
}

export function affiliateLogoForHost(hostname) {
  return resolveUrlHelmetData(hostname)?.icon || null
}
